exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-circle-custom {\n\tborder-radius: 50%;\n\twidth: 25px;\n\theight: 25px;\n}\n", ""]);

// exports
